import GetListQuery from "./GetListQuery";
import QRCodeIcon from "./QRCodeIcon";
import Api from "../../Api";
import HttpClient from "../../HttpClient";
import Page from "../../Page";
import CreateAndPutPayload from "./CreateAndPutPayload";

/**
 * @author Kacper Faber
 * @since 0.1.4
 */
// noinspection JSUnusedGlobalSymbols
class QRCodeIconApi {
    /**
     * Get paginated results.
     * @author Kacper Faber
     * @since 0.1.4
     * @param query
     */
    static getList(query: GetListQuery): Promise<Page<QRCodeIcon>> {
        const url = Api.getUrl('/api/qr-code-icon/');
        return HttpClient.get(url, { ...query });
    }

    /**
     * Deletes QRCodeIcon by ID
     * @param id
     * @author Kacper Faber
     * @since 0.1.4
     */
    static deleteById(id: number): Promise<void> {
        const url = Api.getUrl(`/api/qr-code-icon/${id}/`);
        return HttpClient.execNoContent(url, 'DELETE', {}, {});
    }

    /**
     * Deletes QRCodeIcon.
     * @param model QRCodeIcon with valid ID
     * @author Kacper Faber
     * @since 0.1.4
     */
    static delete(model: QRCodeIcon): Promise<void> {
        const url = Api.getUrl(`/api/qr-code-icon/${model.id}/`);
        return HttpClient.execNoContent(url, 'DELETE', {}, {});
    }

    /**
     * Create new QRCodeIcon
     * @param payload
     * @author Kacper Faber
     * @since 0.1.4
     */
    static create(payload: CreateAndPutPayload): Promise<QRCodeIcon> {
        const url = Api.getUrl('/api/qr-code-icon/');
        return HttpClient.postFormData(url, {}, { ...payload });
    }

    /**
     * Update QRCodeIcon by ID.
     * @param id Resource ID to update.
     * @param payload Payload
     * @author Kacper Faber
     * @since 0.1.4
     */
    static updateById(id: number, payload: CreateAndPutPayload): Promise<QRCodeIcon> {
        const url = Api.getUrl(`/api/qr-code-icon/${id}/`);
        return HttpClient.putFormData(url, {}, { ...payload });
    }

    /**
     * Get QRCodeIcon by it's ID
     * @author Kacper Faber
     * @since 0.1.9
     */
    static getById(id: number | string) {
        const url = Api.getUrl(`/api/qr-code-icon/${id}/`);
        return HttpClient.get<QRCodeIcon>(url, {});
    }
}

// noinspection JSUnusedGlobalSymbols
export default QRCodeIconApi;